// @flow

import React from "react";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";

type Props = {
    updateAvailable: boolean,
    language: string,
    translations: Object
};

const VersionUpdateAlert = ({ updateAvailable, language, translations }: Props) => {

    if (!updateAvailable) {
        return null;
    }

    return (
        <SweetAlert
            title={translations[language]["version"]["title"]}
            onClose={() => {}}
            onConfirm={() => window.location.reload()}
            btnSize="sm"
            confirmBtnBsStyle="success"
            confirmBtnText={translations[language]["version"]["button"]}
        >
            {translations[language]["version"]["message"]}
        </SweetAlert>
    );

};

const mapStateToProps = state => ({
    updateAvailable: state.Version.updateAvailable
});

export default connect(mapStateToProps)(VersionUpdateAlert);